import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../../features/auth/context/AuthContext";
import LoadingScreen from "../ui/loading/LoadingScreen";
import { ROUTES } from "../../core/config";

interface GuestGuardProps {
  children: React.ReactNode;
}

export const GuestGuard = ({ children }: GuestGuardProps) => {
  const { status, isAuthenticated } = useAuth();

  if (status === "initializing") {
    return (
      <LoadingScreen text="Vérification de votre session..." />
    );
  }

  if (isAuthenticated) {
    return <Navigate to={ROUTES.APP_ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
};